import { render } from "./B2bPageAdministracion.vue?vue&type=template&id=509159e8&scoped=true&lang=pug"
import script from "./B2bPageAdministracion.vue?vue&type=script&lang=js"
export * from "./B2bPageAdministracion.vue?vue&type=script&lang=js"

import "./B2bPageAdministracion.vue?vue&type=style&index=0&id=509159e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509159e8"]])

export default __exports__